import React from 'react'
import './index.less'

export default function LinkButton(props) {
    return <button {...props} className="link-button"></button>
}

export function LinkButton1(props) {
  return <button {...props} className="link-button1"></button>
}


export function ClickButton(props) {
  return <button {...props} className="click-button" ></button>
}

export  function WhiteButton(props) {
  return <button {...props} className="white-button"></button>
}

export const CircularButtonWithIcon = ({ imageUrl, onClickHandler,txt }) => {
  return (
    <button
      onClick={onClickHandler}  // Custom click handler
      style={{
        width: '30px',
        height: '30px',
        borderRadius: '50%',  // Makes the button circular
        backgroundColor: '#0984e3', // Background color
        color:'white',
        border: '0px', // Border color
        padding: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        fontSize:'12px'
      }}
    >
    {imageUrl ? (
        <img
          src={imageUrl}
          alt="icon"
          style={{
            width: '30px', // Image size
            height: '30px', // Image size
            borderRadius: '50%', // Ensures the image is circular
          }}
        />
      ) : (
        txt && <span>{txt}</span> // Render text if imageUrl is not provided
      )}
    </button>
  );
};

